import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import DownloadIcon from "@mui/icons-material/Download";

const HearNUFormListUI = ({ loading, onDownloadCsv }) => {
  return (
    <>
      <Box pl={3} pr={3} pb={2} pt={2} component="form">
        <Paper elevation={2} sx={{ pb: 2, pt: 1 }}>
          <Typography variant="h3" sx={{ mb: 5, mt: 3, textAlign: "center" }}>
            Custom HearNU Form Data
          </Typography>

          <Box
            sx={{
              p: 3,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Box p={2}>
              <Button
                sx={{
                  width: "100%",
                  minHeight: "5vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#A91674",
                    color: "white",
                  },
                }}
                onClick={onDownloadCsv}
                variant="outlined"
                component="label"
                fullWidth={true}
              >
                <Typography variant="h5" sx={{ ml: 1 }}>
                  Download Format &nbsp;&nbsp;
                </Typography>

                <DownloadIcon fontSize="medium" />
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default HearNUFormListUI;
